import React from "react";
import { Box, Typography } from "@mui/material";
import ChartBar from "./chart-bar";
import ChartLine from "./chart-line";
import ChartArea from "./chart-area";
import ChartPie from "./chart-pie";

/**
 * Unified chart dispatcher.
 *
 * @param {{ spec: Object, data: Object[], height?: number }} props
 *
 * spec shape:
 *   chartType: "bar" | "line" | "area" | "pie"
 *   xAxis: { key: string, type?: "datetime" | "category" }
 *   series: [{ key, label, color?, stackId?, yAxisId? }]
 *   referenceLines?: [{ y, label, color }]
 *   formatting?: { valueType?: "number" | "percentage" | "duration" | "datetime" }
 */
const Chart = ({ spec, data, height = 300 }) => {
    if (!spec || !data || data.length === 0) {
        return (
            <Box display="flex" alignItems="center" justifyContent="center" height={height}>
                <Typography variant="body2" color="text.secondary">
                    No data
                </Typography>
            </Box>
        );
    }

    switch (spec.chartType) {
        case "bar":
            return <ChartBar spec={spec} data={data} height={height} />;
        case "line":
            return <ChartLine spec={spec} data={data} height={height} />;
        case "area":
            return <ChartArea spec={spec} data={data} height={height} />;
        case "pie":
            return <ChartPie spec={spec} data={data} height={height} />;
        default:
            return (
                <Box display="flex" alignItems="center" justifyContent="center" height={height}>
                    <Typography variant="body2" color="text.secondary">
                        Unsupported chart type: {spec.chartType}
                    </Typography>
                </Box>
            );
    }
};

export default Chart;
